<template>
  <b-container class="main-content details-page" v-if="loading">
    <div class="d-flex align-items-center">
      <strong>Lade Daten...</strong>
      <b-spinner type="grow" label="Loading..." class="loader ml-auto"></b-spinner>
    </div>
    <b-alert show variant="danger" v-if="error">Fehler beim laden!</b-alert>
  </b-container>
  <b-container class="main-content Abstimmung" v-else>

    <p>Abstimmung vom {{ proposal.effectiveDate }}</p>

    <h1>{{ proposal.name }}</h1>

    <div class="row mx-md-n5 mb-4">
      <div class="col px-md-5" style="text-align:center;font-weight: 500">
        <div class="p-3 border bg-light">{{proposal.question}}</div></div>
    </div>

    <b-form @submit.prevent="updateDecision">
      <b-form-row class="row btn-group-toggle mb-4 vote-buttons" data-toggle="buttons" >
        <b-col>
          <input id="decision_yes" type="radio" v-model="decision" value="1" name="options" autocomplete="off" required>
          <label for="decision_yes" class="btn btn-secondary col-sm" >JA</label>
        </b-col>
        <b-col sm="1"></b-col>
        <b-col>
          <input id="decision_neutral" type="radio" v-model="decision" value="3" name="options" autocomplete="off" required>
          <label for="decision_neutral" class="btn btn-secondary col-sm">ENTHALTEN</label>
        </b-col>
        <b-col sm="1"></b-col>
        <b-col>
          <input id="decision_no" type="radio" v-model="decision" value="2" name="options" autocomplete="off" required>
          <label for="decision_no" class="btn btn-secondary col-sm">NEIN</label>
        </b-col>
      </b-form-row>

      <b-form-checkbox
        name="comfirmation"
        unchecked-value="not_accepted"
        v-model="status"
        value="accepted"
        class="mb-4"
        required>Ich bestätige, dass ich mit sämtlichen Konsequenzen meiner Stimme einverstanden bin.
      </b-form-checkbox>
      <div class="text-center mb-2">
        <b-button type="submit" variant="primary" size="lg" block>JETZT ABSTIMMEN</b-button>
      </div>
      <router-link :to="{ name: 'home'}">Abbrechen</router-link>
    </b-form>
  </b-container>
</template>

<script>
import client from 'api-client';

export default {
  name: 'Abstimmung',
  props: ['id', 'code'],
  data() {
    return {
      loading: true,
      decision: '',
      error: false,
      status: 'not_accepted',
      proposals: {},
    };
  },
  created() {
    client
      .fetchProposal(this.id)
      .then(proposal => this.setProposal(proposal))
      .then(vote => this.setVote(vote))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
  },
  methods: {
    setProposal(proposal) {
      this.proposal = proposal;
      this.loading = false;
    },
    setVote(vote) {
      this.vote = vote;
      this.loading = false;
    },
    updateDecision() {
      // Beispiel Vote-Endpoint:
      client
      // 1. Parameter: 16-Stelliger Code
      // 2. Parameter: Entscheidung (Ja = 1, Nein = 2, Enhaltung = 3)
      // 3. Parameter: Geschlecht (m oder f)
      // 4. Parameter: Kanton
      // 5. Parameter: Alter (ageGroup)
        // link im abstimmen button zu danke seite
        .vote(this.code, this.decision, 'f', 'fg')
        .then((result) => {
          this.$router.push({ name: 'danke', params: { id: this.id, code: this.code } });
        })
        .catch((error) => {
          alert(error);
          this.error = true;
        });
    },
  },
};
</script>

<style scoped>
  .vote-buttons input{
    position: absolute;
    top: -9000px;
  }
  .vote-buttons label{
    cursor: pointer;
  }

  .vote-buttons input[type="radio"]:checked+label{
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
  }
</style>
